import Card from "react-bootstrap/Card";

function Component({ data, ...otherProps }) {

  return (
    <Card>
      <Card.Body className="d-flex flex-column">
        <div className="d-flex flex-row justify-content-between">
          <div className="d-flex flex-column">
            <div><img src={data?.bank?.[0]?.bank_logo} style={{ height: 30, objectFit: "cover" }} /></div>
            <div>{data?.bank?.[0]?.bank_name} ({data?.benchmark}) ({data?.property_type})</div>
          </div>
          <div className="d-flex flex-row">
            <div className="d-flex flex-column px-3">
              <div className="text-muted">1st Yr</div>
              <div className="fw-bold">{data.first_year_interest_rate}%</div>
            </div>
            <div className="d-flex flex-column px-3">
              <div className="text-muted">2nd Yr</div>
              <div className="fw-bold">{data.second_year_interest_rate}%</div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );

}

export default Component;
